/**
 * List page index helpers.
 * Page/search must NOT survive leaving a screen (e.g. Dashboard → back to list).
 * Persistence via sessionStorage caused page 8 / filters to stick — disabled.
 */

function clearAllSavedPages() {
  try {
    if (typeof sessionStorage === 'undefined') return;
    const keys = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key && key.indexOf('pagination:') === 0) {
        keys.push(key);
      }
    }
    keys.forEach((key) => sessionStorage.removeItem(key));
  } catch (_e) {
    /* ignore */
  }
}

// Drop any previously saved page numbers from older builds
clearAllSavedPages();

/** Always start at page 1 when a list screen mounts. */
export function getSavedPage(_key) {
  return 1;
}

/** No-op — do not remember page across navigation. */
export function setSavedPage(_key, _page) {
  /* intentionally empty */
}

export function clearSavedPage(key) {
  if (!key) return;
  try {
    sessionStorage.removeItem(`pagination:${key}`);
  } catch (_e) {
    /* ignore */
  }
}

export default {
  getSavedPage,
  setSavedPage,
  clearSavedPage,
};
